<template>
  <v-container>
    <v-dialog v-model="loadDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Excluir</v-card-title>
        <v-divider></v-divider>
        <v-card-text>Deseja excluir a Permissão do Perfil?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#D32F2F" dark class="mr-2 text-capitalize" @click="deleteData(dataID)">Sim</v-btn>
          <v-btn color="#1DE9B6" outlined class="text-capitalize" @click="loadDialog = false">Não</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  <v-card class='text-center'>
    <v-card-title >
      Lista de Permissões
      <v-spacer></v-spacer>
      <v-card-actions>
        <router-link to='/roles'>
          <v-icon color='primary'>mdi-keyboard-return</v-icon>
        </router-link>
      </v-card-actions>
    </v-card-title>
    <ValidationObserver ref="observer" v-slot="{ passes }">
    <v-card-text>
      <ValidationProvider rules="required" v-slot="{ errors }" name="name">
      <v-autocomplete
              multiple
              v-model="permissionsList"
              item-text="name"
              :error-messages='errors'
              item-value="id"
              :items="permissions"
              append-icon="mdi-plus"
              chips
              :menu-props="{closeOnContentClick: false}"
      ></v-autocomplete>
      </ValidationProvider>
      <v-card-actions>
        <v-btn @click="passes(addSubmit)"  color="primary" v-if="checkPermission('role-permission-create')">Adicionar</v-btn>
      </v-card-actions>
    </v-card-text>
    </ValidationObserver>
  </v-card>
   <br>
  <v-card class='text-center'>
    <v-card-title >
  {{`Permissões do Perfil - ${role}`}}
    </v-card-title>
    <v-card-text>
      <div class="mt-4">
        <v-data-table
                :search="search"
                dense
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :items="rowData"
                mobile-breakpoint="900"
                :footer-props="{
                   showFirstLastPage: false,
                     'items-per-page-text':'linhas por página',
                     itemsPerPageOptions:[5,10,20,30,40,50]
                  }"
                sort-by="calories"
                class="border elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-spacer></v-spacer>
              <v-text-field
                      class="mr-3"
                      outlined
                      dense
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Busca"
                      single-line
                      hide-details
              ></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <role-permission-actions
                    @delete-data="openConfirm"
                    :permissions="permissionsAction"
                    :item="item"
            >

            </role-permission-actions>
          </template>
          <template v-if="rowData.length != 0" v-slot:footer.page-text="props">
            {{props.pageStart}} - {{props.pageStop}} de {{props.itemsLength}}
          </template>
        </v-data-table>

<!--        <div class="text-center pt-2">-->
<!--          <v-pagination class="custom" v-model="page" btn="btn" :length="pageCount"></v-pagination>-->
<!--        </div>-->
      </div>
    </v-card-text>
  </v-card>
  </v-container>
</template>

<script>
    import { getPermissions } from '@/graphql/queries/Permission.gql'
    import checkPermissionsMixin from '@/mixins/check-permissions'
    import { getRole, getRolePermissions } from '@/graphql/queries/Role.gql'
    import { AddPermissions, DeletePermission } from '@/graphql/mutations/Role.gql'
    import  RolePermissionActions from './RolePermissionActions'
    import { ValidationObserver, ValidationProvider } from "vee-validate";


export default {
    name:'RolePermissionList',
    mixins:[checkPermissionsMixin],
    components:{
        RolePermissionActions,
        ValidationObserver,
        ValidationProvider
    },
    data: () =>{
        return{
            accessedArea: "roles",
            permissionsList:[],
            rowData:[],
            role: '',
            permissions:[],
            search:'',
            page: 1,
            pageCount: 0,
            loadDialog: false,
            headers: [
                { text: "Menu", align: "left", value: "menu" },
                { text: "Grupo", align: "left", value: "group" },
                { text: "Nome", align: "left", value: "name" },
                { text: "Descrição", align: "left", value: "description" },
                { text: "Ações", value: "actions", sortable: false },
            ],
            permissionsAction: {
                create: true,
                update: true,
                delete: true
            },

        }
    },
    methods: {
        addSubmit() {
            this.$apollo.mutate({
                mutation: AddPermissions,
                variables: {
                    id: this.$route.params.id,
                    permissions: this.permissionsList
                }
            }).then(() => {
                this.$toasted.global.defaultSuccess();
                this.$apollo.queries.rowData.refetch()
                this.permissionsList = []
            }).catch(({graphQLErrors}) => {
                this.$toasted.global.defaultError(graphQLErrors);
                console.error(graphQLErrors)
                this.permission = []
            })
        },
        openConfirm(deleteID) {
            this.dataID = deleteID
            this.loadDialog = true
        },
        deleteData (deleteID) {
            this.$apollo.mutate({
                mutation: DeletePermission,
                variables: {
                    id: this.$route.params.id,
                    permissions: deleteID
                }
            }).then(() => {
             this.$toasted.global.defaultSuccess();
                this.loadDialog = false
                this.$apollo.queries.rowData.refetch()
            }).catch((error) => {
                console.error(error)
            })
        }
    },
    apollo: {
        permissions:{
            query: getPermissions,
            update:(data)=>{
              return data.permissions
            }
        },
        role: {
            query: getRole,
            variables () {
                if (this.$route && this.$route.params.id) {
                    return {
                        id: this.$route.params.id
                    }
                }
            },
            update (data) {
                return data.role.name
            }
        },
        rowData: {
            query: getRolePermissions,
            variables () {
                if (this.$route && this.$route.params.id) {
                    return {
                        id: this.$route.params.id
                    }
                }
            },
            update (data) {
                return data.role.permissions
            }
        }
    },
    mounted() {
        this.$apollo.queries.rowData.refetch()
    }
}

</script>
